import { createFileRoute, redirect } from '@tanstack/react-router';

import { IS_TENANT_CONTEXT_TAB_ENABLED } from '@/config/env';
import TenantContextTab from '@/pages/administration/tabs/tenant-context';

export const Route = createFileRoute('/administration/ai-wizard/tenant-context/')({
  beforeLoad: () => {
    if (!IS_TENANT_CONTEXT_TAB_ENABLED) {
      throw redirect({ to: '/administration/ai-wizard' });
    }
  },
  component: TenantContextTab,
});
